import { render } from "./ScopesTab.vue?vue&type=template&id=d4741276"
import script from "./ScopesTab.vue?vue&type=script&lang=js"
export * from "./ScopesTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__